import { Stack } from 'common/design-system/components-v2';
import styled from 'styled-components';

export const AffectedAssetsTableWrapper = styled(Stack)`
    min-height: 620px;
    border: ${({ theme }) => `${theme.border.width.standard}${theme.units} solid ${theme.palette.border.light}`};
    border-radius: ${({ theme }) => `${theme.border.radius(4)}${theme.units}`};
    gap: 10px;
`;
